import { render, staticRenderFns } from "./IndicatorCreateTabInformation.vue?vue&type=template&id=5048aea9&scoped=true&"
import script from "./IndicatorCreateTabInformation.vue?vue&type=script&lang=js&"
export * from "./IndicatorCreateTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./IndicatorCreateTabInformation.vue?vue&type=style&index=0&id=5048aea9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5048aea9",
  null
  
)

export default component.exports